import { NOMINEE_ACTIONS } from './nomineeActions';

export const INITIAL_STATE = {
  address: {
    lookupFields: {
      postcode: '',
      buildingNumber: '',
    },
    addresses: [],
    selectedAddressReference: '',
    isManualAddress: false,
    manualAddress: {
      addressLineOne: '',
      addressLineTwo: '',
      addressLineThree: '',
      addressLineFour: '',
      postcode: '',
    },
  },
  contact: {
    title: '',
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    day: '',
    month: '',
    year: '',
    emailAddress: '',
    phoneNumber: '',
  },
};

export const nomineeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case NOMINEE_ACTIONS.UPDATE_NOMINEE_DETAILS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case NOMINEE_ACTIONS.RESET: {
      return {
        ...INITIAL_STATE,
      };
    }
    default: {
      return state;
    }
  }
};
